// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_EncerramentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /rede/encerramento — abre (id 0, com a unidade) ou grava um encerramento em andamento
 * (Full). Com id, a unidade casa um encerramento sem unidade; vazia mantém a que ele tem.
 */
import type { Rede_EncerramentoItemEntradaRow } from './Rede_EncerramentoItemEntradaRow'
import { registerContract } from './validate'

export interface Rede_EncerramentoInput {
id?: number
unidade?: string
itens?: Rede_EncerramentoItemEntradaRow[]
distrato?: string
distrato_em?: string
observacao?: string
conferencia_juridico?: string
conferido?: boolean
}

registerContract('Rede_EncerramentoInput', {
  id:                   { type: 'number',  required: false },
  unidade:              { type: 'string',  required: false },
  itens: {
    type: 'array',
    required: false,
    items: {
      item:       { type: 'string',  required: false },
      situacao:   { type: 'string',  required: false },
      observacao: { type: 'string',  required: false },
    },
  },
  distrato:             { type: 'string',  required: false },
  distrato_em:          { type: 'string',  required: false },
  observacao:           { type: 'string',  required: false },
  conferencia_juridico: { type: 'string',  required: false },
  conferido:            { type: 'boolean', required: false },
})
